import { createContext, type Context } from 'react';

export const PlaceholderOverrideValueContext: Context<string | undefined | null> = createContext<
	string | undefined | null
>(null);
